import { omit } from 'ramda';
import { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { devOptionsState } from './state';
type Props = {
  /**
   * The scene/component for which the dev settings apply.
   *
   * This is usually just your scene name
   */
  label: string;
  children: React.ReactNode;
};

/**
 * Render one of these on your scene and whatever children are rendered inside
 * will be displayed on the Dev Menu modal.
 */
export const DevMenuOption = (props: Props) => {
  const setDevOptions = useSetRecoilState(devOptionsState);
  const [lastFor, setLastFor] = useState(props.label);

  useEffect(() => {
    setDevOptions(options => ({
      ...omit([lastFor], options),
      [props.label]: props.children
    }));
    setLastFor(props.label);
    return () => setDevOptions(options => omit([lastFor, props.label], options));
  }, [props.children, props.label]);
  return <></>;
};
